import { SettingsSection } from '@components'

import { Space, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { OrganizationNotificationSettings as OrganizationNotificationSettingsType } from '@modules-deprecated/app/user'
import { useUserNotificationSettings } from '@modules-deprecated/app/user/userNotificationSettingsContext'

import { OrganizationNotificationSettingsContextProvider } from './context/organizationNotificationSettings'
import { OrganizationNotificationSettings } from './elements/OrganizationNotificationSettings'
import { SkeletonNotifications } from './elements/SkeletonNotifications'
import * as Styled from './styles'

export const UserNotificationsSettings = (): ReactElement => {
  const { t } = useTranslation()
  const { userNotificationSettings, isLoading } = useUserNotificationSettings()

  return (
    <>
      <SettingsSection>
        <Styled.NotificationsWrapper>
          <Text variant="h2">{t('notification_settings.title')}</Text>
          <Space size="s8" />
          <Text colorVariant="secondary">{t('notification_settings.intro')}</Text>
          <Space size="s16" />
          {userNotificationSettings?.map(
            (organizationNotificationSettings: OrganizationNotificationSettingsType, i: number) => {
              return (
                <OrganizationNotificationSettingsContextProvider
                  key={i}
                  organizationNotificationSettings={organizationNotificationSettings}
                >
                  <OrganizationNotificationSettings />
                </OrganizationNotificationSettingsContextProvider>
              )
            },
          )}
          {isLoading && <SkeletonNotifications />}
        </Styled.NotificationsWrapper>
      </SettingsSection>
    </>
  )
}
